import { render, staticRenderFns } from "./InputAngle.vue?vue&type=template&id=56f6995e&lang=pug"
import script from "./InputAngle.vue?vue&type=script&lang=js"
export * from "./InputAngle.vue?vue&type=script&lang=js"
import style0 from "./InputAngle.vue?vue&type=style&index=0&id=56f6995e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports